<script>
import SetRowWorkout from '@components/workout/set-row-completed.vue';
import { modalMethods } from '@state/helpers';

import resize from '@utils/image-sizer';

export default {
  components: {
    SetRowWorkout,
  },
  props: {
    exercise: {
      type: Object,
      required: true,
      default: () => {},
    },
  },

  data() {
    return {
      listOfEquipment: [],
      placeholder: require('@assets/images/placeholder-avatar.png'),
    };
  },
  computed: {
    coverPhoto() {
      return this.exercise &&
        this.exercise.mediaAssets &&
        this.exercise.mediaAssets.coverPhoto &&
        this.exercise.mediaAssets.coverPhoto.url
        ? resize(this.exercise.mediaAssets.coverPhoto.url, 245, 138)
        : this.placeholder;
    },
    modalVideo() {
      return this.exercise &&
        this.exercise.mediaAssets &&
        this.exercise.mediaAssets.coverVideo &&
        this.exercise.mediaAssets.coverVideo.url
        ? this.exercise.mediaAssets.coverVideo.url
        : null;
    },
    commaSeperatedListOfEquipment() {
      this.equipmentList();
      if (this.listOfEquipment && this.listOfEquipment.length) {
        return this.listOfEquipment.join(', ');
      }
      return null;
    },
  },
  methods: {
    ...modalMethods,
    equipmentList() {
      if (this.exercise && this.exercise.requiredEquipment && this.exercise.requiredEquipment.weighted) {
        this.listOfEquipment.push(this.exercise.requiredEquipment.weighted.label);
      }
      if (this.exercise && this.exercise.requiredEquipment && this.exercise.requiredEquipment.unweighted.length) {
        this.exercise.requiredEquipment.unweighted.map((equipment) => this.listOfEquipment.push(equipment.label));
      }
    },
    async showModal(src) {
      await this.setSelectedVideo({
        src,
        exerciseName: this.exercise.label,
        numberOfReps: this.exercise.setDirections[0].reps,
        weight: this.exercise.setDirections[0].weight,
        timeOfExercise: this.exercise.setDirections[0].time,
        listOfEquipment: this.commaSeperatedListOfEquipment,
      });
      this.$bvModal.show('video-preview-modal');
    },
  },
};
</script>

<template>
  <div class="exercise-set-details">
    <div class="row">
      <div class="col col-md-4 no-pad-right">
        <div class="row no-pad-horizontal">
          <div class="col-lg-6 col-xl-4 exercise-photo">
            <img :src="coverPhoto" />
          </div>
          <div class="col">
            <h3 class="equipment-title">{{ commaSeperatedListOfEquipment }}</h3>
            <h3 class="exercise-title">{{ exercise.label }}</h3>
            <div class="row">
              <div class="col set-details">
                <div class="exercise-set-details-header">
                  <span class="set-details-title">Sets</span>
                </div>
                <div class="row">
                  <div class="col">
                    <p class="set-num">{{ exercise && exercise.setDirections ? exercise.setDirections.length : 0 }}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <BaseButton type="button" class="button btn-secondary btn-round btn-add-more" @click.stop="showModal(modalVideo)">
            <strong>Preview</strong>
          </BaseButton>
        </div>
      </div>
      <div class="col set-details-container">
        <div class="exercise-set-details-header">
          <div class="row">
            <div class="col">
              <span class="set-details-title">Reps</span>
            </div>
            <div class="col">
              <span class="set-details-title">Time</span>
            </div>
            <div class="col">
              <span class="set-details-title">Weight</span>
            </div>
            <div class="col">
              <span class="set-details-title">Rest After</span>
            </div>
          </div>
        </div>
        <SetRowWorkout v-for="(set, i) in exercise.setDirections" :key="i" :set="set" />
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import '@design';
// stylelint-disable no-descending-specificity
// stylelint-disable selector-pseudo-element-no-unknown

.exercise-set-details {
  padding-top: 4rem;
  transition: all 300ms;

  &:not(:first-child) {
    border-top: 6px solid #efefef;
  }

  .row {
    display: flex;
    flex-wrap: nowrap;
    justify-content: space-between;
    .set-details {
      margin-top: 3rem;
      max-width: 30%;
      .set-num {
        color: $color-tag-text;
        font-size: 2.4rem;
        font-weight: 600;
        margin-top: 2rem;
        text-align: center;
      }
    }

    &.no-pad-horizontal {
      @extend %no-pad-horizontal;
    }

    .no-pad-right {
      flex-shrink: 0;
      padding-right: 0;
      .no-pad-horizontal,
      %no-pad-horizontal {
        padding-left: 10rem;
        padding-right: 5rem;
        position: relative;
      }
      .row {
        padding-left: 0;
        padding-right: 0;

        .btn-add-more {
          font-size: 1.75rem;
          margin-bottom: 2.4rem;
          margin-left: 6rem;
          padding: 1.5rem 5rem;

          .icon-curl {
            width: 1.4rem;
          }
        }
      }

      .exercise-title {
        font-family: $base-font-family;
        font-size: 2.1rem;
        font-weight: 900;
        letter-spacing: -0.3px;
        line-height: 2.4rem;
        margin-bottom: 1.6rem;
      }

      .equipment-title {
        color: #888;
        font-family: $base-font-family;
        font-size: 1.2rem;
        font-weight: bold;
        // letter-spacing: 1.34675px;
        line-height: 1.6rem;
        text-transform: uppercase;
      }

      .exercise-photo {
        align-items: flex-start;
        display: flex;
        justify-content: flex-end;
        padding-left: 10%;
        padding-right: 0;
        position: relative;
        img {
          border-radius: 4px;
          object-fit: cover;
          width: 100%;
        }
      }
    }

    .set-details-container {
      margin-right: 4rem;
      max-width: 50%;
    }
    .exercise-set-details-header {
      border-bottom: 1px solid $color-light-gray;
      padding: 0 0 1rem;
      position: relative;
      text-align: center;

      .set-details-title {
        color: $color-text;
        font-size: 1.2rem;
        font-weight: bold;
        letter-spacing: 1.34675px;
        line-height: 1.6rem;
        text-transform: uppercase;
      }
      .col {
        text-align: center;
      }
    }
  }
  @media only screen and (max-width: 1000px) {
    .no-pad-right {
      .no-pad-horizontal {
        display: flex;
        flex-direction: column;
        .col {
          align-items: center;
          display: flex;
          flex-direction: column;
          justify-content: center;
        }
      }
    }
  }
}
</style>
